/*
* @Author: abhishek714
* @Date:   2025-05-29 12:47:14
* @Last Modified by:   abhishek714
* @Last Modified time: 2025-05-29 12:47:51
*/
export const MAIL_FORMAT = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const NUMBER_FORMATE = /^\d+$/;
export const ucwords = (str) => {
    if (!str) return ''; // Add a check for undefined or empty string
    return str.toLowerCase().replace(/\b\w/g, function(char) {
      return char.toUpperCase();
    });
}
export const firstChar = (str) => {
    return ucwords(Array.from(str)[0]);
}
export const formatUSD = (value) =>
    new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
    .format(Number(value || 0))
    .replace('$', '')
    .trim();